import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Handles /admin#session_id=... redirect from Emergent Auth.
 * Exchanges session_id for a session_token cookie, then routes to /admin.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/admin/login', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        await refresh();
        navigate('/admin', { replace: true, state: { user: data } });
      } catch (err) {
        const detail = err?.response?.data?.detail || 'Login failed';
        navigate('/admin/login', { replace: true, state: { error: detail } });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF2E8]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-[#F39200] border-t-transparent rounded-full animate-spin mx-auto" />
        <div className="mt-4 text-sm text-neutral-600">Signing you in…</div>
      </div>
    </div>
  );
}
